/**
 * DEVBRAINS MOCK DATA
 * ─────────────────────────────────────────────────────────────────
 * All data is centralized here. To integrate a real API, replace
 * each exported constant with an async service call.
 *
 * Example API integration:
 *   import { getMentors } from '../services/api';
 *   const mentors = await getMentors({ page, filters });
 * ─────────────────────────────────────────────────────────────────
 */

// ─── MENTORS ────────────────────────────────────────────────────
export const MENTORS = [
  {
    id: 1,
    slug: 'amar-krishnan',
    name: 'Amar Krishnan',
    initials: 'AK',
    avatarSeed: 'Amar',
    avatarBg: '16a34a',
    role: 'Senior Software Engineer',
    company: 'Ex-Google',
    companyLogo: '🔵',
    location: 'Bengaluru, India 🇮🇳',
    skills: ['React', 'Node.js', 'AWS', 'System Design', 'TypeScript'],
    specialization: 'Full-Stack Web',
    experience: 8,
    rating: 4.97,
    reviewCount: 234,
    sessionsCompleted: 412,
    priceINR: 1600,
    badge: 'Top Mentor',
    badgeType: 'green',
    availabilityLabel: '● Today 3PM',
    availabilityColor: '#16a34a',
    isAvailableToday: true,
    languages: ['English', 'Tamil', 'Hindi'],
    bio: 'Ex-Google engineer with 8 years building scalable systems. Specialized in React, Node.js, and cloud architecture. I help engineers level up from mid to senior level.',
    sessionTypes: ['1:1 Mentoring', 'Code Review', 'Mock Interview', 'Career Roadmap'],
    timezone: 'IST (UTC+5:30)',
    responseTime: 'Usually within 1 hour',
    totalEarned: 98000,
  },
  {
    id: 2,
    slug: 'siti-nabilah',
    name: 'Siti Nabilah',
    initials: 'SN',
    avatarSeed: 'Siti',
    avatarBg: '2563eb',
    role: 'ML Engineer',
    company: 'Shopee',
    companyLogo: '🛍️',
    location: 'Kuala Lumpur, Malaysia 🇲🇾',
    skills: ['AI/ML', 'Python', 'TensorFlow', 'PyTorch', 'LLMs'],
    specialization: 'AI / Machine Learning',
    experience: 6,
    rating: 5.0,
    reviewCount: 412,
    sessionsCompleted: 788,
    priceINR: 2400,
    badge: 'AI Expert',
    badgeType: 'blue',
    availabilityLabel: '● Today 5PM',
    availabilityColor: '#16a34a',
    isAvailableToday: true,
    languages: ['English', 'Malay'],
    bio: 'ML Engineer at Shopee building recommendation systems serving 300M+ users. Expert in large language models, computer vision, and MLOps. Passionate about democratizing AI education.',
    sessionTypes: ['1:1 Mentoring', 'Code Review', 'Mock Interview', 'Project-Based Cert'],
    timezone: 'MYT (UTC+8)',
    responseTime: 'Usually within 2 hours',
    totalEarned: 185000,
  },
  {
    id: 3,
    slug: 'raj-mehta',
    name: 'Raj Mehta',
    initials: 'RM',
    avatarSeed: 'Raj',
    avatarBg: '7c3aed',
    role: 'Mobile Engineering Lead',
    company: 'Grab',
    companyLogo: '🚗',
    location: 'Singapore 🇸🇬',
    skills: ['Flutter', 'Dart', 'Firebase', 'iOS', 'Android'],
    specialization: 'Mobile Development',
    experience: 5,
    rating: 4.83,
    reviewCount: 178,
    sessionsCompleted: 256,
    priceINR: 1200,
    badge: '',
    badgeType: '',
    availabilityLabel: '● Tomorrow',
    availabilityColor: '#b45309',
    isAvailableToday: false,
    languages: ['English', 'Hindi'],
    bio: 'Mobile lead at Grab, building super-app features used by 35M+ users. 5 years shipping production Flutter apps for iOS and Android. Code review specialist.',
    sessionTypes: ['1:1 Mentoring', 'Code Review', 'Career Roadmap'],
    timezone: 'SGT (UTC+8)',
    responseTime: 'Usually within 3 hours',
    totalEarned: 67000,
  },
  {
    id: 4,
    slug: 'priya-patel',
    name: 'Priya Patel',
    initials: 'PP',
    avatarSeed: 'Priya',
    avatarBg: 'dc2626',
    role: 'Cloud Architect',
    company: 'Microsoft',
    companyLogo: '🪟',
    location: 'Hyderabad, India 🇮🇳',
    skills: ['AWS', 'Azure', 'Kubernetes', 'DevOps', 'Terraform'],
    specialization: 'Cloud & DevOps',
    experience: 10,
    rating: 4.91,
    reviewCount: 302,
    sessionsCompleted: 520,
    priceINR: 2800,
    badge: 'Top Mentor',
    badgeType: 'green',
    availabilityLabel: '● Today 7PM',
    availabilityColor: '#16a34a',
    isAvailableToday: true,
    languages: ['English', 'Hindi', 'Gujarati'],
    bio: 'Cloud Architect at Microsoft with 10 years designing infrastructure for Fortune 500 companies. AWS + Azure certified. Expert in Kubernetes, CI/CD, and cost optimization.',
    sessionTypes: ['1:1 Mentoring', 'Code Review', 'Mock Interview', 'Project-Based Cert'],
    timezone: 'IST (UTC+5:30)',
    responseTime: 'Usually within 1 hour',
    totalEarned: 210000,
  },
  {
    id: 5,
    slug: 'kevin-tan',
    name: 'Kevin Tan',
    initials: 'KT',
    avatarSeed: 'Kevin',
    avatarBg: '0891b2',
    role: 'Security Engineer',
    company: 'TikTok',
    companyLogo: '🎵',
    location: 'Jakarta, Indonesia 🇮🇩',
    skills: ['Cybersecurity', 'Pentesting', 'OWASP', 'Kali Linux', 'CTF'],
    specialization: 'Cybersecurity',
    experience: 7,
    rating: 4.78,
    reviewCount: 145,
    sessionsCompleted: 198,
    priceINR: 1800,
    badge: '',
    badgeType: '',
    availabilityLabel: '● This week',
    availabilityColor: '#6b7280',
    isAvailableToday: false,
    languages: ['English', 'Indonesian', 'Mandarin'],
    bio: 'Security engineer at TikTok leading the red team. Former CTF champion. Expert in web application security, penetration testing, and secure software development.',
    sessionTypes: ['1:1 Mentoring', 'Code Review', 'Mock Interview'],
    timezone: 'WIB (UTC+7)',
    responseTime: 'Usually within 4 hours',
    totalEarned: 89000,
  },
  {
    id: 6,
    slug: 'meera-jayaram',
    name: 'Meera Jayaram',
    initials: 'MJ',
    avatarSeed: 'Meera',
    avatarBg: 'd97706',
    role: 'Principal Product Designer',
    company: 'Axiata',
    companyLogo: '📡',
    location: 'Kuala Lumpur, Malaysia 🇲🇾',
    skills: ['UI/UX', 'Figma', 'Design Systems', 'User Research', 'Prototyping'],
    specialization: 'UI/UX Design',
    experience: 6,
    rating: 4.95,
    reviewCount: 267,
    sessionsCompleted: 389,
    priceINR: 1400,
    badge: 'Design Pro',
    badgeType: 'purple',
    availabilityLabel: '● Today 2PM',
    availabilityColor: '#16a34a',
    isAvailableToday: true,
    languages: ['English', 'Tamil', 'Malay'],
    bio: 'Principal Designer at Axiata leading design for fintech products. 6 years crafting beautiful, accessible interfaces. Author of the DevBrains Design Handbook.',
    sessionTypes: ['1:1 Mentoring', 'Portfolio Review', 'Career Roadmap'],
    timezone: 'MYT (UTC+8)',
    responseTime: 'Usually within 2 hours',
    totalEarned: 124000,
  },
  {
    id: 7,
    slug: 'liang-wei-chen',
    name: 'Liang Wei Chen',
    initials: 'LC',
    avatarSeed: 'Liang',
    avatarBg: '059669',
    role: 'Data Science Lead',
    company: 'GoTo',
    companyLogo: '🛵',
    location: 'Jakarta, Indonesia 🇮🇩',
    skills: ['Data Science', 'Python', 'SQL', 'Spark', 'Analytics'],
    specialization: 'Data Science',
    experience: 7,
    rating: 4.89,
    reviewCount: 198,
    sessionsCompleted: 344,
    priceINR: 2000,
    badge: '',
    badgeType: '',
    availabilityLabel: '● Today 6PM',
    availabilityColor: '#16a34a',
    isAvailableToday: true,
    languages: ['English', 'Mandarin', 'Indonesian'],
    bio: 'Data Science Lead at GoTo Group working on fraud detection and demand forecasting. 7 years turning messy data into business insights. Kaggle Grandmaster.',
    sessionTypes: ['1:1 Mentoring', 'Code Review', 'Mock Interview'],
    timezone: 'WIB (UTC+7)',
    responseTime: 'Usually within 2 hours',
    totalEarned: 143000,
  },
  {
    id: 8,
    slug: 'fatima-al-rashid',
    name: 'Fatima Al-Rashid',
    initials: 'FR',
    avatarSeed: 'Fatima',
    avatarBg: 'be185d',
    role: 'Backend Engineer',
    company: 'Maybank',
    companyLogo: '🏦',
    location: 'Kuala Lumpur, Malaysia 🇲🇾',
    skills: ['Java', 'Spring Boot', 'Microservices', 'Kafka', 'PostgreSQL'],
    specialization: 'Backend Engineering',
    experience: 9,
    rating: 4.88,
    reviewCount: 221,
    sessionsCompleted: 311,
    priceINR: 2200,
    badge: '',
    badgeType: '',
    availabilityLabel: '● Tomorrow',
    availabilityColor: '#b45309',
    isAvailableToday: false,
    languages: ['English', 'Arabic', 'Malay'],
    bio: 'Senior Backend Engineer at Maybank building real-time payment infrastructure. Expert in Java, Spring Boot, and high-throughput distributed systems.',
    sessionTypes: ['1:1 Mentoring', 'Code Review', 'Mock Interview', 'Career Roadmap'],
    timezone: 'MYT (UTC+8)',
    responseTime: 'Usually within 3 hours',
    totalEarned: 156000,
  },
  {
    id: 9,
    slug: 'ankit-sharma',
    name: 'Ankit Sharma',
    initials: 'AS',
    avatarSeed: 'Ankit',
    avatarBg: 'ea580c',
    role: 'GenAI / LLM Engineer',
    company: 'Petronas Digital',
    companyLogo: '⚡',
    location: 'Kuala Lumpur, Malaysia 🇲🇾',
    skills: ['GenAI', 'LLMs', 'LangChain', 'RAG', 'OpenAI API'],
    specialization: 'AI / Machine Learning',
    experience: 4,
    rating: 4.92,
    reviewCount: 167,
    sessionsCompleted: 289,
    priceINR: 2600,
    badge: 'Rising Star',
    badgeType: 'amber',
    availabilityLabel: '● Today 4PM',
    availabilityColor: '#16a34a',
    isAvailableToday: true,
    languages: ['English', 'Hindi'],
    bio: 'Building enterprise GenAI solutions at Petronas Digital. Expert in LangChain, RAG pipelines, and fine-tuning open-source LLMs. Shipped 12 production AI products.',
    sessionTypes: ['1:1 Mentoring', 'Code Review', 'Project-Based Cert'],
    timezone: 'MYT (UTC+8)',
    responseTime: 'Usually within 1 hour',
    totalEarned: 112000,
  },
];

// ─── TECHNOLOGIES (for filters) ───────────────────────────────
export const TECHNOLOGIES = [
  { value: '', label: 'All Technologies' },
  { value: 'ai-ml', label: 'AI / Machine Learning' },
  { value: 'react', label: 'React / Next.js' },
  { value: 'nodejs', label: 'Node.js' },
  { value: 'flutter', label: 'Flutter / Dart' },
  { value: 'python', label: 'Python' },
  { value: 'cloud', label: 'Cloud / AWS' },
  { value: 'devops', label: 'DevOps' },
  { value: 'cybersecurity', label: 'Cybersecurity' },
  { value: 'uiux', label: 'UI/UX Design' },
  { value: 'data-science', label: 'Data Science' },
  { value: 'genai', label: 'GenAI / LLMs' },
];

// ─── SKILL CHIPS ───────────────────────────────────────────────
export const SKILL_CHIPS = [
  { label: '🤖 AI/ML', key: 'AI/ML' },
  { label: '⚛️ React', key: 'React' },
  { label: '🐍 Python', key: 'Python' },
  { label: '☁️ Cloud', key: 'AWS' },
  { label: '📱 Flutter', key: 'Flutter' },
  { label: '🔐 Security', key: 'Cybersecurity' },
  { label: '🎨 UI/UX', key: 'UI/UX' },
  { label: '⚙️ DevOps', key: 'DevOps' },
  { label: '📊 Data Science', key: 'Data Science' },
  { label: '🧠 GenAI/LLM', key: 'GenAI' },
];

// ─── CERTIFICATIONS ───────────────────────────────────────────
export const CERTIFICATIONS = [
  {
    id: 1,
    icon: '🤖',
    name: 'AI/ML Engineering',
    slug: 'ai-ml',
    desc: 'Build production ML models, deploy to cloud, work with LLMs and neural networks.',
    skills: ['Python', 'TensorFlow', 'PyTorch', 'MLOps'],
    duration: '8 weeks',
    priceINR: 8999,
    popular: true,
    level: 'Intermediate',
    enrolled: 1240,
  },
  {
    id: 2,
    icon: '⚛️',
    name: 'Full-Stack Web Dev',
    slug: 'full-stack',
    desc: 'Build complete web applications with React, Node.js, databases, and cloud deployment.',
    skills: ['React', 'Node.js', 'MongoDB', 'AWS'],
    duration: '10 weeks',
    priceINR: 7499,
    popular: false,
    level: 'Beginner–Intermediate',
    enrolled: 2180,
  },
  {
    id: 3,
    icon: '📱',
    name: 'Mobile Development',
    slug: 'mobile',
    desc: 'Create cross-platform mobile apps for iOS and Android with Flutter and Firebase.',
    skills: ['Flutter', 'Dart', 'Firebase', 'REST APIs'],
    duration: '8 weeks',
    priceINR: 6999,
    popular: false,
    level: 'Beginner–Intermediate',
    enrolled: 980,
  },
  {
    id: 4,
    icon: '☁️',
    name: 'Cloud & DevOps',
    slug: 'cloud-devops',
    desc: 'Master cloud infrastructure, CI/CD pipelines, containers, and site reliability engineering.',
    skills: ['AWS', 'Docker', 'K8s', 'Terraform'],
    duration: '6 weeks',
    priceINR: 7999,
    popular: false,
    level: 'Intermediate',
    enrolled: 760,
  },
  {
    id: 5,
    icon: '🔐',
    name: 'Cybersecurity',
    slug: 'cybersecurity',
    desc: 'Learn offensive and defensive security, penetration testing, and secure development.',
    skills: ['Pentesting', 'OWASP', 'Kali Linux', 'CTF'],
    duration: '10 weeks',
    priceINR: 8499,
    popular: false,
    level: 'Intermediate–Advanced',
    enrolled: 620,
  },
  {
    id: 6,
    icon: '🎨',
    name: 'UI/UX Design',
    slug: 'uiux',
    desc: 'Design user-centered digital products from research to high-fidelity prototypes.',
    skills: ['Figma', 'Design Systems', 'UX Research', 'Prototyping'],
    duration: '6 weeks',
    priceINR: 5999,
    popular: false,
    level: 'Beginner',
    enrolled: 1420,
  },
];

// ─── TESTIMONIALS ─────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    id: 1,
    quote: 'Landed my dream job at Grab after 3 sessions with my mentor. The resume review + mock interview practice was exactly what I needed. 100% worth it!',
    name: 'Priya Sharma',
    role: 'Frontend Engineer @ Grab',
    avatarSeed: 'PriyaS',
    avatarBg: '16a34a',
    initials: 'PS',
    rating: 5,
    featured: true,
  },
  {
    id: 2,
    quote: 'The project-based certification gave me confidence and a portfolio piece. My mentor reviewed every single line of my code and pushed me to write better software.',
    name: 'Ahmad Farouk',
    role: 'Full-Stack Dev · KL',
    avatarSeed: 'AhmadF',
    avatarBg: '2563eb',
    initials: 'AF',
    rating: 5,
    featured: false,
  },
  {
    id: 3,
    quote: 'As a career switcher from banking, I was lost. My DevBrains mentor gave me a clear roadmap. Got my first tech offer in 4 months!',
    name: 'Li Wei Chen',
    role: 'Junior Developer · Singapore',
    avatarSeed: 'LiWei',
    avatarBg: '7c3aed',
    initials: 'LC',
    rating: 5,
    featured: false,
  },
];

// ─── PLATFORM STATS ───────────────────────────────────────────
export const PLATFORM_STATS = [
  { num: '2,400+', label: 'Verified Mentors' },
  { num: '18,000+', label: 'Sessions Completed' },
  { num: '1,200+', label: 'Certificates Issued' },
  { num: '4.9 ★', label: 'Average Rating' },
  { num: '50+ 🌍', label: 'Countries Served' },
];

// ─── SERVICES ─────────────────────────────────────────────────
export const SERVICES = [
  { id: 1, color: 'green', icon: '🎯', title: '1:1 Mentoring Sessions', desc: 'Private, focused sessions with your chosen expert. Ask anything, share your screen, get unstuck — on your schedule.', priceINR: 999, priceUnit: '/hr' },
  { id: 2, color: 'blue', icon: '💻', title: 'Code Review', desc: 'Submit your project or PR for a thorough review. Get line-by-line feedback, architecture advice, and best-practice guidance.', priceINR: 1199, priceUnit: '/session' },
  { id: 3, color: 'amber', icon: '🎤', title: 'Mock Interview Prep', desc: 'Simulate real technical interviews with engineers from FAANG, Google, Microsoft, and top global tech companies.', priceINR: 1499, priceUnit: '/session' },
  { id: 4, color: 'purple', icon: '🏆', title: 'Project-Based Certificates', desc: 'Build a real project, defend it in oral review, and earn a blockchain-verified certificate that employers actually trust.', priceINR: 3999, priceUnit: '/track' },
  { id: 5, color: 'rose', icon: '🗺️', title: 'Career Roadmap', desc: '30-min call with a senior mentor who maps out your exact path from where you are to your dream tech role.', priceINR: 799, priceUnit: '/session' },
  { id: 6, color: 'teal', icon: '👥', title: 'Group Workshops', desc: 'Join cohort-based learning sessions — cheaper than 1:1, but still mentor-led and hands-on with real projects.', priceINR: 499, priceUnit: '/person' },
];

// ─── CURRENCY CONFIG ──────────────────────────────────────────
export const CURRENCIES = [
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', flag: '🇮🇳', rate: 1 },
  { code: 'USD', symbol: '$', name: 'US Dollar', flag: '🇺🇸', rate: 0.012 },
  { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit', flag: '🇲🇾', rate: 0.056 },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', flag: '🇸🇬', rate: 0.016 },
];

// ─── HELPER: Convert price ────────────────────────────────────
export function convertPrice(priceINR, currency) {
  const curr = CURRENCIES.find(c => c.code === currency) || CURRENCIES[0];
  const converted = priceINR * curr.rate;
  if (currency === 'INR') return `${curr.symbol}${converted.toLocaleString('en-IN')}`;
  return `${curr.symbol}${converted < 10 ? converted.toFixed(2) : Math.round(converted).toLocaleString()}`;
}

// ─── HELPER: Get avatar URL ────────────────────────────────────
export function getAvatarUrl(seed, bg = '1DB954', size = 80) {
  return `https://api.dicebear.com/9.x/personas/svg?seed=${encodeURIComponent(seed)}&backgroundColor=${bg}&radius=12`;
}

// ─── FAQ ──────────────────────────────────────────────────────
export const FAQS = [
  {
    q: 'How quickly can I book a session?',
    a: "You can book within 60 seconds. Search for your skill, pick an available slot (many mentors have slots today), pay securely via Razorpay, and you're confirmed. No lengthy registration or waiting period needed.",
  },
  {
    q: 'What payment methods are accepted?',
    a: "We accept all major credit/debit cards, FPX online banking, Touch 'n Go eWallet, GrabPay, Boost, and more — all processed securely through Razorpay with 256-bit SSL encryption. Your card details are never stored on our servers.",
  },
  {
    q: 'Is my first session really free?',
    a: 'Yes! Every new mentee gets one free 30-minute introductory session with a mentor of their choice. No credit card needed to claim it — just sign up and book.',
  },
  {
    q: 'Can I become a mentor on DevBrains?',
    a: 'Yes! If you have 3+ years of relevant tech experience, apply as a mentor. You set your own rates (top mentors earn ₹40,000–₹1,60,000/month), choose your own hours, and DevBrains handles all bookings and payments. 85% of every session fee goes directly to you.',
  },
  {
    q: 'How are project-based certificates different?',
    a: 'Unlike course completion certificates, DevBrains certificates require you to build a real project from scratch, submit daily progress, receive code review, and pass a 1-on-1 technical interview with your mentor. Employers trust them because the bar is genuinely high.',
  },
];

// ─── MENTOR REVIEWS (per mentor, by mentorId) ─────────────────
export const MENTOR_REVIEWS = {
  1: [
    { id: 1, name: 'Rahul Verma', initials: 'RV', avatarSeed: 'RahulV', avatarBg: '0ea5e9', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Amar is phenomenal. In just 2 sessions he helped me understand React architecture and system design concepts that I had been struggling with for months. He draws diagrams in real-time and explains everything from first principles. Highly recommend!' },
    { id: 2, name: 'Priya Menon', initials: 'PM', avatarSeed: 'PriyaM', avatarBg: 'be185d', rating: 5, date: 'Nov 2024', sessionType: 'Mock Interview', comment: 'Best mock interview session I have ever had. Amar simulated a real Google-style interview and gave me precise feedback on my communication, coding approach, and time management. Got my offer 3 weeks later!' },
    { id: 3, name: 'Kevin Das', initials: 'KD', avatarSeed: 'KevinD', avatarBg: '7c3aed', rating: 5, date: 'Nov 2024', sessionType: 'Code Review', comment: 'Super detailed code review. He went through every file, pointed out anti-patterns and security issues I never noticed, and explained the right way to structure a Node.js API. Worth every rupee.' },
    { id: 4, name: 'Sneha Iyer', initials: 'SI', avatarSeed: 'SnehaI', avatarBg: 'ea580c', rating: 4, date: 'Oct 2024', sessionType: '1:1 Mentoring', comment: 'Very knowledgeable about AWS and cloud architecture. The session ran a bit over time which was actually a bonus. Could improve on response times between sessions but the quality of mentoring itself is top-notch.' },
    { id: 5, name: 'Arjun Nair', initials: 'AN', avatarSeed: 'ArjunN', avatarBg: '16a34a', rating: 5, date: 'Oct 2024', sessionType: 'Career Roadmap', comment: 'I had no idea how to transition from a 3-year service company background to a product company. Amar mapped out a 6-month plan that was specific, realistic, and incredibly motivating. Following it now!' },
    { id: 6, name: 'Divya Krishnan', initials: 'DK', avatarSeed: 'DivyaK', avatarBg: '2563eb', rating: 5, date: 'Sep 2024', sessionType: '1:1 Mentoring', comment: 'I was completely stuck on TypeScript generics and Amar explained them in the most intuitive way using real-world examples from his Google projects. Outstanding mentor.' },
  ],
  2: [
    { id: 1, name: 'Ahmad Farouk', initials: 'AF', avatarSeed: 'AhmadF', avatarBg: '2563eb', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Siti is simply the best AI/ML mentor I have found. She explains complex neural network architectures like transformer attention mechanisms in such a clear way. After 4 sessions, I built my first production model!' },
    { id: 2, name: 'Nur Aina', initials: 'NA', avatarSeed: 'NurAina', avatarBg: '16a34a', rating: 5, date: 'Dec 2024', sessionType: 'Project-Based Cert', comment: 'Completed the AI/ML certification track with Siti as my mentor. She was available every time I got stuck, provided very detailed code review, and pushed me to think beyond the basics. My project is now in production.' },
    { id: 3, name: 'Rohan Pillai', initials: 'RP', avatarSeed: 'RohanP', avatarBg: 'ea580c', rating: 5, date: 'Nov 2024', sessionType: 'Mock Interview', comment: 'Siti helped me prepare for my ML Engineer interview at a unicorn startup. She covered all the ML system design questions and had me practice explaining my model decisions clearly. Got the role!' },
    { id: 4, name: 'Lina Ooi', initials: 'LO', avatarSeed: 'LinaO', avatarBg: '7c3aed', rating: 5, date: 'Nov 2024', sessionType: '1:1 Mentoring', comment: 'Coming from a pure math background, I was intimidated by the engineering side of ML. Siti bridged that gap perfectly. She showed me how to take my Jupyter notebooks to scalable pipelines. Exceptional.' },
    { id: 5, name: 'Vikram Shah', initials: 'VS', avatarSeed: 'VikramS', avatarBg: '0891b2', rating: 4, date: 'Oct 2024', sessionType: 'Code Review', comment: 'Very thorough review of my PyTorch training code. Siti caught a critical data leakage bug that was skewing my validation accuracy. Saved me weeks of confusion. Deducting one star only because I had to wait a few days for scheduling.' },
  ],
  3: [
    { id: 1, name: 'James Lim', initials: 'JL', avatarSeed: 'JamesL', avatarBg: '7c3aed', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Raj helped me get my first Flutter app from 0 to the Play Store. He has a clear, systematic approach and never lets you get away with messy code. Two months of sessions, and I feel like a completely different developer.' },
    { id: 2, name: 'Sasha Tan', initials: 'ST', avatarSeed: 'SashaT', avatarBg: 'be185d', rating: 5, date: 'Nov 2024', sessionType: 'Code Review', comment: 'My Flutter codebase was a mess of setState calls everywhere. Raj introduced me to proper BLoC architecture, refactored my code live during the session, and explained the reasoning. My app performance improved significantly.' },
    { id: 3, name: 'Hira Khan', initials: 'HK', avatarSeed: 'HiraK', avatarBg: '16a34a', rating: 4, date: 'Nov 2024', sessionType: '1:1 Mentoring', comment: 'Solid mentor with great depth in Flutter and Firebase. Helped me integrate real-time notifications and Firestore efficiently. Scheduling can sometimes take a day or two but worth the wait.' },
  ],
  4: [
    { id: 1, name: 'Suresh Kumar', initials: 'SK', avatarSeed: 'SureshK', avatarBg: 'dc2626', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Priya is an absolute expert in cloud architecture. She helped me design a multi-region AWS setup for our SaaS product and explained trade-offs at every decision point. I could not have done this without her.' },
    { id: 2, name: 'Meghna Bose', initials: 'MB', avatarSeed: 'MeghnaB', avatarBg: '2563eb', rating: 5, date: 'Dec 2024', sessionType: 'Mock Interview', comment: 'Cracked my AWS Solutions Architect Professional exam after 3 mock sessions with Priya. She knew exactly which topics would be on the test and where my gaps were. Incredibly efficient mentoring.' },
    { id: 3, name: 'Tanvir Ahmed', initials: 'TA', avatarSeed: 'TanvirA', avatarBg: '16a34a', rating: 5, date: 'Nov 2024', sessionType: 'Code Review', comment: 'Priya reviewed our Terraform codebase and caught three security misconfigurations we had missed. She also improved our CI/CD pipeline significantly. Our cloud costs dropped by 30% after implementing her recommendations.' },
    { id: 4, name: 'Chen Ling', initials: 'CL', avatarSeed: 'ChenL', avatarBg: '7c3aed', rating: 5, date: 'Nov 2024', sessionType: '1:1 Mentoring', comment: 'Best DevOps mentoring I have experienced. Priya has genuine depth on Kubernetes internals, not just surface-level knowledge. My team now runs a production K8s cluster confidently thanks to her guidance.' },
  ],
  5: [
    { id: 1, name: 'Reza Fadhli', initials: 'RF', avatarSeed: 'RezaF', avatarBg: '0891b2', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Kevin is a phenomenal security mentor. He walked me through OWASP Top 10 vulnerabilities using live examples on my own web app. I found SQL injection and XSS vulnerabilities in my code I had no idea about.' },
    { id: 2, name: 'Aisha Bello', initials: 'AB', avatarSeed: 'AishaB', avatarBg: 'be185d', rating: 5, date: 'Nov 2024', sessionType: 'Mock Interview', comment: 'Kevin prepared me for my security engineer interview in just 2 sessions. He covered CTF-style thinking, common interview scenarios, and how to present security findings professionally. Got the job!' },
    { id: 3, name: 'David Ng', initials: 'DN', avatarSeed: 'DavidN', avatarBg: '16a34a', rating: 4, date: 'Oct 2024', sessionType: 'Code Review', comment: 'Great security code review. Kevin found several authentication weaknesses in my Node.js app and showed me exactly how an attacker would exploit them. Practical, no-nonsense approach.' },
  ],
  6: [
    { id: 1, name: 'Isma Johari', initials: 'IJ', avatarSeed: 'IsmaJ', avatarBg: 'd97706', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Meera transformed my design skills in just 5 sessions. She has a gift for breaking down complex design principles into actionable steps. My Figma skills went from beginner to a level where I landed a junior UX role.' },
    { id: 2, name: 'Preethi Ramesh', initials: 'PR', avatarSeed: 'PreethiR', avatarBg: '16a34a', rating: 5, date: 'Nov 2024', sessionType: 'Portfolio Review', comment: 'Meera reviewed my portfolio with brutal honesty and kindness at the same time. She identified exactly why I was not getting callbacks and helped me rebuild my case studies with proper UX thinking. Got 3 interviews in 2 weeks after.' },
    { id: 3, name: 'Zara Hussain', initials: 'ZH', avatarSeed: 'ZaraH', avatarBg: '7c3aed', rating: 5, date: 'Nov 2024', sessionType: 'Career Roadmap', comment: 'Amazing career mentoring from Meera. She helped me navigate the transition from graphic design to UX, gave me a realistic roadmap, and connected me with her network. Truly went above and beyond.' },
    { id: 4, name: 'Fariz Azmi', initials: 'FA', avatarSeed: 'FarizA', avatarBg: '2563eb', rating: 5, date: 'Oct 2024', sessionType: '1:1 Mentoring', comment: 'Learned design systems properly for the first time. Meera showed me how to build atomic components, manage tokens, and structure a Figma library that scales. My developer handoffs are now seamless.' },
  ],
  7: [
    { id: 1, name: 'Budi Santoso', initials: 'BS', avatarSeed: 'BudiS', avatarBg: '059669', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Liang Wei is a master at translating business problems into data science solutions. He helped me build a churn prediction model end-to-end and taught me how to present findings to non-technical stakeholders.' },
    { id: 2, name: 'Indira Patel', initials: 'IP', avatarSeed: 'IndiraP', avatarBg: 'dc2626', rating: 4, date: 'Nov 2024', sessionType: 'Mock Interview', comment: 'Very strong data science interviewer. He covers case studies, SQL, statistics, and machine learning questions methodically. Helped me get comfortable with open-ended analytical questions.' },
  ],
  8: [
    { id: 1, name: 'Ramesh Rao', initials: 'RR', avatarSeed: 'RameshR', avatarBg: 'be185d', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Fatima is an exceptional Java/Spring mentor. She helped me understand microservices architecture with Kafka from scratch and reviewed my entire codebase. My team adopted her suggestions and our system is much more reliable.' },
  ],
  9: [
    { id: 1, name: 'Kiran Babu', initials: 'KB', avatarSeed: 'KiranB', avatarBg: 'ea580c', rating: 5, date: 'Dec 2024', sessionType: '1:1 Mentoring', comment: 'Ankit is the best GenAI mentor out there. He helped me build a RAG pipeline for our internal knowledge base from scratch. He explains LangChain concepts clearly and has hands-on experience with real production LLM systems.' },
    { id: 2, name: 'Lakshmi Nair', initials: 'LN', avatarSeed: 'LakshmiN', avatarBg: '7c3aed', rating: 5, date: 'Nov 2024', sessionType: 'Code Review', comment: 'Reviewed my LLM fine-tuning code and identified several inefficiencies in my data pipeline and training loop. Ankit is very up-to-date with the latest research and best practices. Highly recommended for anyone working with LLMs.' },
  ],
};

// ─── AVAILABILITY SLOTS (per mentor, by mentorId) ────────────
// In real API: GET /mentors/:id/availability?month=2025-01
//
// NOTE: dates are computed lazily (function call) so they are always
// relative to TODAY at render time — not frozen at module-load time.
// Uses LOCAL date parts (getFullYear/Month/Date) instead of toISOString()
// to avoid UTC-vs-local mismatches in IST / MYT / UTC− timezones.
const localDateStr = (dt) => {
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const d = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
const futureDate = (offset) => {
  const dt = new Date();
  dt.setDate(dt.getDate() + offset);
  return localDateStr(dt);
};

export const MENTOR_AVAILABILITY = {
  1: {
    get availableDates() {
      return [0,1,3,5,7,8,10,12,14,16,18,21,23,25,28,30].map(futureDate);
    },
    timeSlots: ['9:00 AM','10:00 AM','11:00 AM','2:00 PM','3:00 PM','4:00 PM','5:00 PM','7:00 PM'],
  },
  2: {
    get availableDates() {
      return [0,2,4,6,9,11,13,15,18,20,22,25,27,29].map(futureDate);
    },
    timeSlots: ['10:00 AM','11:00 AM','1:00 PM','3:00 PM','5:00 PM','7:00 PM','9:00 PM'],
  },
  3: {
    get availableDates() {
      return [1,3,6,8,10,13,15,17,20,22,24,27,29].map(futureDate);
    },
    timeSlots: ['9:00 AM','11:00 AM','2:00 PM','4:00 PM','6:00 PM','8:00 PM'],
  },
  4: {
    get availableDates() {
      return [0,1,2,5,7,9,12,14,16,19,21,23,26,28,30].map(futureDate);
    },
    timeSlots: ['8:00 AM','10:00 AM','12:00 PM','2:00 PM','6:00 PM','8:00 PM'],
  },
  5: {
    get availableDates() {
      return [2,4,6,9,11,13,16,18,20,23,25,27,30].map(futureDate);
    },
    timeSlots: ['10:00 AM','2:00 PM','4:00 PM','7:00 PM','9:00 PM'],
  },
  6: {
    get availableDates() {
      return [0,1,4,6,8,11,13,15,18,20,22,25,27,29].map(futureDate);
    },
    timeSlots: ['9:00 AM','10:30 AM','1:00 PM','2:30 PM','4:00 PM','6:00 PM'],
  },
  7: {
    get availableDates() {
      return [0,2,5,7,10,12,14,17,19,21,24,26,28].map(futureDate);
    },
    timeSlots: ['9:00 AM','11:00 AM','1:00 PM','3:00 PM','5:00 PM','8:00 PM'],
  },
  8: {
    get availableDates() {
      return [1,3,6,8,10,13,15,17,20,22,25,27,29].map(futureDate);
    },
    timeSlots: ['10:00 AM','12:00 PM','3:00 PM','5:00 PM','7:00 PM'],
  },
  9: {
    get availableDates() {
      return [0,1,3,5,7,9,11,14,16,18,21,23,25,28,30].map(futureDate);
    },
    timeSlots: ['8:00 AM','10:00 AM','12:00 PM','2:00 PM','4:00 PM','6:00 PM','8:00 PM'],
  },
};

// ─── SESSION TYPES (per mentor) ───────────────────────────────
export const SESSION_TYPES = {
  '1:1 Mentoring': {
    icon: '🎯', duration: '60 min', multiplier: 1.0, discountPct: 10,
    badge: 'Most Popular', badgeColor: 'green',
    desc: 'Private 1-on-1 session with your mentor on any topic you choose.',
    includes: [
      'Live screen sharing & collaborative coding',
      'Recorded session link sent after (on request)',
      'Follow-up notes & curated resources',
      'Open Q&A — ask anything, go at your pace',
      'Actionable next steps & personalised plan',
    ],
    idealFor: 'Developers who are stuck, want architecture advice, or need a focused deep-dive on any tech topic.',
    whatToPrepare: 'Write down 2–3 specific questions or the problem you want to solve before the session.',
  },
  'Code Review': {
    icon: '💻', duration: '45 min', multiplier: 0.8, discountPct: 0,
    badge: null,
    desc: 'Expert line-by-line review of your code with written feedback & improvements.',
    includes: [
      'Line-by-line code walkthrough with comments',
      'Architecture & design pattern suggestions',
      'Security, performance & maintainability checks',
      'Refactored code snippets where needed',
      'Written summary delivered after the session',
    ],
    idealFor: 'Developers who want expert eyes on their project, PR, or portfolio code before shipping.',
    whatToPrepare: 'Share your GitHub repo link or paste the specific file/function you want reviewed.',
  },
  'Mock Interview': {
    icon: '🎤', duration: '60 min', multiplier: 1.0, discountPct: 15,
    badge: '15% off', badgeColor: 'amber',
    desc: 'Realistic technical interview simulation with scored feedback to land your dream offer.',
    includes: [
      'Timed coding problems (LeetCode-style or system design)',
      'Interviewer-style follow-up questions',
      'Live scoring on communication, approach & solution',
      'Full written feedback report after the session',
      'Tips on how to improve for next round',
    ],
    idealFor: 'Engineers preparing for FAANG, product companies, or senior-level interviews who want real practice under pressure.',
    whatToPrepare: 'Tell your mentor the company, role level, and interview round (coding / system design / behavioural).',
  },
  'Career Roadmap': {
    icon: '🗺️', duration: '30 min', multiplier: 0.5, discountPct: 0,
    badge: 'Best Value', badgeColor: 'blue',
    desc: '30-min strategic session to map your exact path from where you are to your dream role.',
    includes: [
      'Honest assessment of your current skills & gaps',
      'Step-by-step 3–6 month action plan',
      'Recommended learning resources & projects',
      'Salary benchmarks & negotiation tips',
      'Follow-up resource list via email',
    ],
    idealFor: 'Developers at a career crossroads — transitioning roles, targeting a specific company, or feeling stuck in their growth.',
    whatToPrepare: 'Share your current resume (PDF or link) and your target role/company in the booking note.',
  },
  'Portfolio Review': {
    icon: '🖼️', duration: '45 min', multiplier: 0.8, discountPct: 10,
    badge: '10% off', badgeColor: 'purple',
    desc: 'Full portfolio audit with actionable feedback to make your work stand out to recruiters.',
    includes: [
      'Review of all portfolio projects & live demos',
      'Feedback on project scope, tech choices & presentation',
      'GitHub profile & README best practices',
      'Recruiter perspective: what stands out vs. what to cut',
      'Prioritised list of improvements with examples',
    ],
    idealFor: 'Developers applying for jobs who want their portfolio to convert views into interview calls.',
    whatToPrepare: 'Share your portfolio URL and GitHub profile link before the session.',
  },
  'Project-Based Cert': {
    icon: '🏆', duration: 'Multi-week', multiplier: 2.5, discountPct: 0,
    badge: 'Certificate Included', badgeColor: 'gold',
    desc: 'Guided 6–10 week certification program — build a real project, defend it, earn a verified certificate.',
    includes: [
      '6–10 weekly mentor-guided sessions',
      'Hands-on project from design to deployment',
      'Code reviews at every milestone',
      'Oral defence session with your mentor',
      'Blockchain-verified certificate upon completion',
    ],
    idealFor: 'Developers who want a structured learning path, a portfolio project, and a credential employers trust.',
    whatToPrepare: 'Browse the certification tracks at devbrains.in/certifications and mention your chosen track in the booking note.',
  },
};

// ─── HELPER: Get mentor by slug ───────────────────────────────
export function getMentorBySlug(slug) {
  return MENTORS.find(m => m.slug === slug) || null;
}

// ═══════════════════════════════════════════════════════
//  DASHBOARD MOCK DATA
// ═══════════════════════════════════════════════════════

// ─── MENTOR DASHBOARD DATA ────────────────────────────
export const MENTOR_DASHBOARD = {
  stats: {
    totalSessions: 412, upcoming: 8, completed: 389, cancelled: 15,
    totalEarnings: 312400, monthEarnings: 28600, pendingPayout: 14200,
    walletBalance: 38450, avgRating: 4.97, totalReviews: 234,
    isAvailable: true,
  },
  upcomingSessions: [
    { id:'s1', mentee:'Rahul Verma', menteeAvatar:'RahulV', menteeBg:'2563eb', menteeInit:'RV', type:'1:1 Mentoring', date:'2026-03-04', time:'3:00 PM', duration:'60 min', priceINR:1600, status:'confirmed', topic:'React State Management & Redux', meetingPlatform:'google_meet', meetLink:'https://meet.google.com/abc-def-ghi' },
    { id:'s2', mentee:'Sneha Iyer', menteeAvatar:'SnehaI', menteeBg:'dc2626', menteeInit:'SI', type:'Mock Interview', date:'2026-03-06', time:'11:00 AM', duration:'60 min', priceINR:1600, status:'confirmed', topic:'System Design Interview Prep', meetingPlatform:'zoom', meetLink:'https://zoom.us/j/123456789?pwd=devbrains' },
    { id:'s3', mentee:'Arjun Nair', menteeAvatar:'ArjunN', menteeBg:'d97706', menteeInit:'AN', type:'Code Review', date:'2026-03-07', time:'5:00 PM', duration:'45 min', priceINR:1280, status:'pending', topic:'Node.js API Architecture Review', meetingPlatform:'google_meet', meetLink:'' },
    { id:'s4', mentee:'Divya Krishnan', menteeAvatar:'DivyaK', menteeBg:'7c3aed', menteeInit:'DK', type:'Career Roadmap', date:'2026-03-09', time:'2:00 PM', duration:'30 min', priceINR:800, status:'confirmed', topic:'Mid to Senior Engineer Roadmap', meetingPlatform:'teams', meetLink:'https://teams.microsoft.com/l/meetup-join/devbrains-test' },
  ],
  pastSessions: [
    { id:'p1', mentee:'Priya Menon', menteeInit:'PM', menteeBg:'be185d', type:'Mock Interview', date:'2026-02-28', time:'10:00 AM', priceINR:1600, status:'completed', rating:5, reviewed:true },
    { id:'p2', mentee:'Kevin Das', menteeInit:'KD', menteeBg:'059669', type:'Code Review', date:'2026-02-25', time:'3:00 PM', priceINR:1280, status:'completed', rating:5, reviewed:true },
    { id:'p3', mentee:'Riya Singh', menteeInit:'RS', menteeBg:'0891b2', type:'1:1 Mentoring', date:'2026-02-22', time:'5:00 PM', priceINR:1600, status:'completed', rating:4, reviewed:true },
    { id:'p4', mentee:'Vikram Shah', menteeInit:'VS', menteeBg:'ea580c', type:'1:1 Mentoring', date:'2026-02-20', time:'7:00 PM', priceINR:1600, status:'cancelled', rating:null, reviewed:false },
    { id:'p5', mentee:'Meera Raj', menteeInit:'MR', menteeBg:'d97706', type:'Career Roadmap', date:'2026-02-18', time:'11:00 AM', priceINR:800, status:'completed', rating:5, reviewed:false },
  ],
  transactions: [
    { id:'t1', date:'28 Feb 2026', description:'Session - Priya Menon (Mock Interview)', gross:1600, commission:240, net:1360, status:'released' },
    { id:'t2', date:'25 Feb 2026', description:'Session - Kevin Das (Code Review)', gross:1280, commission:192, net:1088, status:'released' },
    { id:'t3', date:'22 Feb 2026', description:'Session - Riya Singh (1:1 Mentoring)', gross:1600, commission:240, net:1360, status:'released' },
    { id:'t4', date:'18 Feb 2026', description:'Session - Meera Raj (Career Roadmap)', gross:800, commission:120, net:680, status:'pending' },
    { id:'t5', date:'15 Feb 2026', description:'Session - Anand Kumar (Code Review)', gross:1280, commission:192, net:1088, status:'released' },
    { id:'t6', date:'10 Feb 2026', description:'Payout to Bank Account', gross:0, commission:0, net:-12000, status:'paid_out' },
  ],
  monthlyEarnings: [
    { month:'Sep', amount:18400 }, { month:'Oct', amount:22100 }, { month:'Nov', amount:19800 },
    { month:'Dec', amount:25600 }, { month:'Jan', amount:21300 }, { month:'Feb', amount:28600 },
  ],
  slots: {
    availableDays: ['Mon','Tue','Wed','Thu','Fri'],
    timeSlots: ['9:00 AM','10:00 AM','11:00 AM','2:00 PM','3:00 PM','4:00 PM','5:00 PM','7:00 PM'],
    maxPerDay: 4, bufferMinutes: 15, sameDayBooking: true,
  },
};

// ─── MENTEE DASHBOARD DATA ────────────────────────────
export const MENTEE_DASHBOARD = {
  stats: { totalSessions: 12, upcoming: 2, completed: 9, cancelled: 1, totalSpent: 14400 },
  upcomingSessions: [
    { id:'ms1', mentor:'Amar Krishnan', mentorAvatar:'Amar', mentorBg:'16a34a', mentorInit:'AK', type:'1:1 Mentoring', date:'2026-03-04', time:'3:00 PM', duration:'60 min', priceINR:1600, status:'confirmed', topic:'React State Management & Redux', meetingPlatform:'google_meet', meetLink:'https://meet.google.com/abc-def-ghi' },
    { id:'ms2', mentor:'Siti Nabilah', mentorAvatar:'Siti', mentorBg:'2563eb', mentorInit:'SN', type:'Mock Interview', date:'2026-03-10', time:'5:00 PM', duration:'60 min', priceINR:2400, status:'confirmed', topic:'ML Engineer Interview Prep', meetingPlatform:'zoom', meetLink:'https://zoom.us/j/987654321?pwd=devbrains' },
  ],
  pastSessions: [
    { id:'mp1', mentor:'Amar Krishnan', mentorInit:'AK', mentorBg:'16a34a', type:'Code Review', date:'2026-02-20', time:'4:00 PM', priceINR:1280, status:'completed', rated:true, myRating:5, canRate:false },
    { id:'mp2', mentor:'Meera Jayaram', mentorInit:'MJ', mentorBg:'d97706', type:'Career Roadmap', date:'2026-02-12', time:'11:00 AM', priceINR:800, status:'completed', rated:false, myRating:null, canRate:true },
    { id:'mp3', mentor:'Raj Mehta', mentorInit:'RM', mentorBg:'7c3aed', type:'1:1 Mentoring', date:'2026-02-05', time:'9:00 AM', priceINR:1200, status:'cancelled', rated:false, myRating:null, canRate:false },
  ],
  invoices: [
    { id:'inv001', date:'2026-02-20', mentor:'Amar Krishnan', type:'Code Review', amount:1280, status:'paid' },
    { id:'inv002', date:'2026-02-12', mentor:'Meera Jayaram', type:'Career Roadmap', amount:800, status:'paid' },
    { id:'inv003', date:'2026-01-28', mentor:'Amar Krishnan', type:'1:1 Mentoring', amount:1600, status:'refunded' },
    { id:'inv004', date:'2026-01-15', mentor:'Raj Mehta', type:'1:1 Mentoring', amount:1200, status:'paid' },
  ],
  supportTickets: [
    { id:'tkt001', subject:'Payment not reflected after session', priority:'high', status:'in_progress', created:'2026-02-21', lastUpdate:'2026-02-22', messages:3 },
    { id:'tkt002', subject:'Unable to reschedule session', priority:'medium', status:'resolved', created:'2026-01-30', lastUpdate:'2026-02-01', messages:5 },
    { id:'tkt003', subject:'Invoice download not working', priority:'low', status:'closed', created:'2026-01-15', lastUpdate:'2026-01-16', messages:2 },
  ],
};

// ─── ADMIN DASHBOARD DATA ─────────────────────────────
export const ADMIN_DASHBOARD = {
  platformStats: {
    totalMentors: 2412, pendingApproval: 34, totalMentees: 18640,
    totalBookings: 24180, activeBookings: 247, totalRevenue: 8420000,
    monthRevenue: 680000, commissionEarned: 1263000, avgRating: 4.87,
    openTickets: 18, resolvedToday: 12,
  },
  pendingMentors: [
    { id:'pm1', name:'Sanjay Kumar', email:'sanjay@example.com', role:'Backend Engineer', company:'Infosys', exp:6, skills:['Java','Spring Boot','Microservices'], submittedDate:'28 Feb 2026', docs:['ID','Certificate'], avatarSeed:'SanjayK', avatarBg:'0891b2', initials:'SK' },
    { id:'pm2', name:'Anika Patel', email:'anika@example.com', role:'Data Scientist', company:'PhonePe', exp:5, skills:['Python','ML','SQL'], submittedDate:'27 Feb 2026', docs:['ID','Resume'], avatarSeed:'AnikaP', avatarBg:'be185d', initials:'AP' },
    { id:'pm3', name:'Rohit Sharma', email:'rohit@example.com', role:'DevOps Engineer', company:'Flipkart', exp:7, skills:['AWS','K8s','Terraform'], submittedDate:'26 Feb 2026', docs:['ID','Certificate','Resume'], avatarSeed:'RohitS', avatarBg:'d97706', initials:'RS' },
    { id:'pm4', name:'Kavita Nair', email:'kavita@example.com', role:'UI/UX Designer', company:'CRED', exp:4, skills:['Figma','Prototyping','Design Systems'], submittedDate:'25 Feb 2026', docs:['ID','Portfolio'], avatarSeed:'KavitaN', avatarBg:'7c3aed', initials:'KN' },
  ],
  recentBookings: [
    { id:'bk001', mentee:'Rahul Verma', mentor:'Amar Krishnan', type:'1:1 Mentoring', date:'2026-03-04', amount:1600, status:'confirmed', commission:240 },
    { id:'bk002', mentee:'Sneha Iyer', mentor:'Siti Nabilah', type:'Mock Interview', date:'2026-03-06', amount:2400, status:'confirmed', commission:360 },
    { id:'bk003', mentee:'James Lim', mentor:'Raj Mehta', type:'Code Review', date:'2026-03-03', amount:1200, status:'completed', commission:180 },
    { id:'bk004', mentee:'Priya Menon', mentor:'Priya Patel', type:'1:1 Mentoring', date:'2026-03-02', amount:2800, status:'completed', commission:420 },
    { id:'bk005', mentee:'Tanvir Ahmed', mentor:'Kevin Tan', type:'1:1 Mentoring', date:'2026-03-01', amount:1800, status:'cancelled', commission:0 },
    { id:'bk006', mentee:'Isma Johari', mentor:'Meera Jayaram', type:'Career Roadmap', date:'2026-02-28', amount:1400, status:'completed', commission:210 },
  ],
  allUsers: [
    { id:'u101', name:'Amar Krishnan', email:'mentor@devbrains.com', role:'mentor', status:'active', joined:'Mar 2024', sessions:412, rating:4.97, avatarSeed:'Amar', avatarBg:'16a34a', init:'AK' },
    { id:'u102', name:'Siti Nabilah', email:'siti@shopee.com', role:'mentor', status:'active', joined:'Apr 2024', sessions:788, rating:5.0, avatarSeed:'Siti', avatarBg:'2563eb', init:'SN' },
    { id:'u103', name:'Raj Mehta', email:'raj@grab.com', role:'mentor', status:'active', joined:'May 2024', sessions:256, rating:4.83, avatarSeed:'Raj', avatarBg:'7c3aed', init:'RM' },
    { id:'u104', name:'Rahul Verma', email:'mentee@devbrains.com', role:'mentee', status:'active', joined:'Jan 2025', sessions:12, rating:null, avatarSeed:'RahulV', avatarBg:'2563eb', init:'RV' },
    { id:'u105', name:'Sneha Iyer', email:'sneha@gmail.com', role:'mentee', status:'active', joined:'Nov 2024', sessions:8, rating:null, avatarSeed:'SnehaI', avatarBg:'dc2626', init:'SI' },
    { id:'u106', name:'James Lim', email:'james@email.com', role:'mentee', status:'suspended', joined:'Oct 2024', sessions:3, rating:null, avatarSeed:'JamesL', avatarBg:'d97706', init:'JL' },
  ],
  tickets: [
    { id:'tkt001', user:'Rahul Verma', role:'mentee', subject:'Payment not reflected after session', priority:'high', status:'in_progress', created:'21 Feb 2026', assignedTo:'Support Team' },
    { id:'tkt002', user:'Amar Krishnan', role:'mentor', subject:'Payout delay for February', priority:'medium', status:'open', created:'20 Feb 2026', assignedTo:'Unassigned' },
    { id:'tkt003', user:'Sneha Iyer', role:'mentee', subject:'Unable to reschedule session', priority:'medium', status:'resolved', created:'15 Feb 2026', assignedTo:'Support Team' },
    { id:'tkt004', user:'James Lim', role:'mentee', subject:'Mentor did not join session', priority:'high', status:'open', created:'14 Feb 2026', assignedTo:'Unassigned' },
    { id:'tkt005', user:'Raj Mehta', role:'mentor', subject:'Profile photo not updating', priority:'low', status:'closed', created:'10 Feb 2026', assignedTo:'Tech Team' },
  ],
  revenueByMonth: [
    { month:'Sep', revenue:520000, commission:78000 },
    { month:'Oct', revenue:610000, commission:91500 },
    { month:'Nov', revenue:580000, commission:87000 },
    { month:'Dec', revenue:720000, commission:108000 },
    { month:'Jan', revenue:650000, commission:97500 },
    { month:'Feb', revenue:680000, commission:102000 },
  ],
};
